





















































import { Lead } from '@/requests/mainApi/models/Lead';
import { storeModuleName } from '@/views/App/Profile/store';
import Vue from 'vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import { mapActions, mapMutations, mapGetters } from 'vuex';
import NoDealsStub from './NoDealsStub.vue';
import { LeadV1LeadListRequest } from '@/requests/mainApi/apis/LeadApi';
import { getAccessToken } from '@/utils/plugins/jwt';
import { BASE_PATH } from '@/requests/requestMachine';

interface Data {
  deals: {
    mdCount: number | null;
    mdPage: number | null;
    mdData: Lead[];
  };
  rowsPerPage: number;
}

interface Methods {
  getLeads: (payload: LeadV1LeadListRequest) => Promise<{
    next: LeadV1LeadListRequest;
    prev: LeadV1LeadListRequest;
    count: number;
    results: Lead[];
  }>;
  updatePagination: (page: number, pageSize: number) => void;
  setReminderModalOpen: (open: boolean) => void;
  setApprovalModalOpen: (open: boolean) => void;
  setCurrentReminderLink: (link: string) => void;
  setCurrentLeadToApprove: (lead: Lead | null) => void;
  setCurrentMortgageLink: (link: string) => void;
  addLeadMemoLog: (leadMemoId: number | null) => void;
  createMortgageOrder: (lead: Lead) => Promise<{ link: string }>;
  onCreateOrderSuccess: (res: { link: string }) => void;
  goToCheckListPage: (leadId: number | string) => void;
  handleReminderClick: (lead: Lead) => void;
  setSubmitDocumentsModalOpen: (open: boolean) => void;
  setCurrentLeadForDocuments: (lead: Lead | null) => void;
}

interface Computed {
  loadingDeals: boolean;
  currentLeadToApprove: Lead | null;
}

interface Props {}

export default Vue.extend({
  name: 'MyDealsTable',
  components: {
    NoDealsStub,
  },
  data() {
    return {
      deals: {
        mdCount: null,
        mdPage: null,
        mdData: [],
      },
      rowsPerPage: 10,
    };
  },
  created() {
    this.updatePagination(0, this.rowsPerPage);
  },
  computed: {
    ...mapGetters(storeModuleName, ['loadingDeals']),
    ...mapGetters(['currentLeadToApprove']),
  },

  methods: {
    updatePagination(page: number, pageSize: number) {
      if (this.deals.mdPage === page && this.rowsPerPage === pageSize) {
        return;
      }

      this.getLeads({ offset: this.rowsPerPage !== pageSize ? 0 : page * pageSize, limit: pageSize }).then(leads => {
        this.deals.mdCount = leads.count || 10;
        this.deals.mdData = leads.results.length ? leads.results : [];
        this.deals.mdPage = page === 0 ? 1 : page;
        this.rowsPerPage = pageSize;
      });
    },
    ...mapActions(storeModuleName, ['getLeads']),
    ...mapActions(['createMortgageOrder']),
    ...mapMutations([
      'setReminderModalOpen',
      'setApprovalModalOpen',
      'setCurrentReminderLink',
      'setCurrentLeadToApprove',
      'setCurrentMortgageLink',
      'setSubmitDocumentsModalOpen',
      'setCurrentLeadForDocuments',
    ]),
    handleReminderClick(item: Lead) {
      this.setCurrentReminderLink(item.memo);
      this.addLeadMemoLog(item.leadMemo.id);
      this.setReminderModalOpen(true);
    },
    addLeadMemoLog(leadMemoId: number|null) {
      if (!leadMemoId) return;

      const token = getAccessToken();

      fetch(`${BASE_PATH}/lead/v1/lead-memo/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          lead_memo_id: leadMemoId,
        }),
      });
    },
    onCreateOrderSuccess(res: { link: string }) {
      window.open(res?.link);
      const token = getAccessToken();

      const listener = (e: any) => {
        if (!(e.data?.event && e.data?.event === 'MORTGAGE_QUESTIONNAIRE_SIGNET')) {
          return;
        }

        fetch(`${BASE_PATH}/booking/v1/mortgage-application/confirm`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            leadId: this.currentLeadToApprove.leadId,
          }),
        });

        window.removeEventListener('message', listener);
      };

      window.addEventListener('message', listener);
    },
    goToCheckListPage(leadId: number | string) {
      this.$router.push(`/check-list/${leadId}`);
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
